import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '../components/ui/Tooltip';
import { docIcon } from './docIcons';

/**
 * Left column: the sections tree. With a search query only the matching pages
 * remain. A page whose `tool` is hidden from the rail stays listed (Help is
 * where you find out a tool exists) but dimmed, with a tooltip saying why.
 */
export default function HelpNav({ sections, matches, currentId, hidden, onOpen, query }) {
  const { t } = useTranslation();
  const hiddenSet = new Set(hidden || []);
  const matchIds = new Set(matches.map((p) => p.id));
  const visible = sections
    .map((section) => ({ ...section, pages: section.pages.filter((p) => matchIds.has(p.id)) }))
    .filter((section) => section.pages.length > 0);

  if (!visible.length) {
    return <p className="help-nav-empty">{t('help.noResults', { query })}</p>;
  }

  return (
    <nav aria-label={t('help.sections')}>
      {visible.map((section) => (
        <div key={section.id} className="help-nav-group">
          <h6>{section.title}</h6>
          {section.pages.map((page) => {
            const Icon = docIcon(page.icon);
            const dim = page.tool && hiddenSet.has(page.tool);
            const link = (
              <button
                key={page.id}
                type="button"
                className={`help-nav-item${page.id === currentId ? ' help-nav-item--on' : ''}${dim ? ' help-nav-item--dim' : ''}`}
                aria-current={page.id === currentId ? 'page' : undefined}
                // Explicit, or Tooltip would name the button after its hint.
                aria-label={dim ? `${page.title} (${t('help.hiddenFromRail')})` : undefined}
                data-page-id={page.id}
                onClick={() => onOpen(page.id)}
              >
                <Icon size={15} aria-hidden="true" />
                <span>{page.title}</span>
              </button>
            );
            return dim ? (
              <Tooltip key={page.id} content={t('help.hiddenFromRail')} side="right">
                {link}
              </Tooltip>
            ) : (
              link
            );
          })}
        </div>
      ))}
    </nav>
  );
}
